var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLitterExpensesViewEntries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "litter_expenses_view_entries") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "litter_expenses_view_entries"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.46.66a16.94,16.94,0,0,0-17,16.87V428.38a16.94,16.94,0,0,0,17,16.87H582.34a16.94,16.94,0,0,0,17-16.87V17.53a16.94,16.94,0,0,0-17-16.87",
    fill: "#febe10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.39,
    y: 76.8,
    width: 380.92,
    height: 444.6,
    rx: 16.79,
    fill: "#ffd77d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.56,270.87V582.61a17,17,0,0,1-17.26,16.72H17.89A17,17,0,0,1,.64,582.61V171.45a17,17,0,0,1,17.25-16.72H261.68a18,18,0,0,1,5.85,1L380,263.94A16.29,16.29,0,0,1,381.56,270.87Z",
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.79,262.94h-95a17.2,17.2,0,0,1-17.43-17V154.71Z",
    fill: "#febe10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.05,
    y: 371.41,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.93 1.42) rotate(-0.43)",
    fill: "#febe10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.17,
    y: 517,
    width: 133.73,
    height: 36.28,
    rx: 12,
    transform: "translate(-4.03 0.94) rotate(-0.43)",
    fill: "#febe10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.49,
    y: 298.86,
    width: 262.23,
    height: 36.28,
    rx: 12,
    transform: "translate(-2.39 1.41) rotate(-0.43)",
    fill: "#febe10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.61,
    y: 443.96,
    width: 261.46,
    height: 36.28,
    rx: 12,
    transform: "translate(-3.48 1.42) rotate(-0.43)",
    fill: "#febe10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitterExpensesViewEntries);
export default __webpack_public_path__ + "static/media/litter_expenses_view_entries.d65ce5c9d0abbb1963feaaa83c6c1503.svg";
export { ForwardRef as ReactComponent };